import { ListaDocumentosTH } from "@/componentes/talento/ListaDocumentosTH"

/**
 * Lo que el empleado pide a Talento Humano —permisos, vacaciones, constancias— y lo
 * que ya le resolvieron.
 *
 * ⚠ **Entrada propia del menú y no una pestaña de Talento humano**: la usa todo el
 * personal (`documento_th:solicitar`), y Talento humano pide `talento_humano:ver`,
 * que abre fichas ajenas. El servidor sólo le devuelve lo suyo.
 */
export function MisSolicitudes() {
  return (
    <div>
      <header className="mb-4">
        <h1 className="text-xl font-semibold">Mis solicitudes</h1>
        <p className="text-sm" style={{ color: "var(--fg-muted)" }}>
          Pide permisos, vacaciones y constancias: salen llenos con los datos de tu ficha.
        </p>
      </header>
      <ListaDocumentosTH modo="autoservicio" />
    </div>
  )
}
